import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Router from './router';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableCurrencyListAsync } from './redux/fiat-currencies';
import {
  setAccountsPageSpotlightExpired,
  setNodeLunchSpotlightExpired,
  setThemeSpotlightVisited,
} from './redux/feature-spotlights';
import { RootState } from 'typesafe-actions';
import { ThemeModeType } from './layouts/components/dark-mode-toggle';

const Root = () => {
  // below line is mandatory for react suspense to work, do not remove
  // eslint-disable-next-line no-empty-pattern
  const {} = useTranslation();
  const dispatch = useDispatch();
  const mode = useSelector((state: RootState) => state.theme.mode);

  useEffect(() => {
    dispatch(getAvailableCurrencyListAsync.request({}));
    dispatch(setAccountsPageSpotlightExpired());
    dispatch(setNodeLunchSpotlightExpired());

    if (mode === ThemeModeType.dark) {
      dispatch(setThemeSpotlightVisited(true));
    }
  }, []);
  return <Router />;
};

export default Root;
